import { Box } from '@material-ui/core';
import { formatDateTimeReadable, getLoanById, getOrderDetailsByLoanId } from '@nemuru-eng/js-api-client';

import { OverviewDetailRow } from '@/components/shared/components/OverviewDetailRow';
import { PurchaseCountryWithFlag } from '@/components/shared/components/PurchaseCountryWithFlag';
import { Text } from '@/components/shared/components/Text';
import { useCache } from '@/hooks/requests/useCache';

const OrderHeaderDetails = ({ loanId, showClientData }: { loanId: string; showClientData: boolean }) => {
  const { data: orderDetails } = useCache(getOrderDetailsByLoanId, { loanId });
  const { data: loan } = useCache(getLoanById, { loanId });

  return orderDetails && loan ? (
    <Box display={'flex'} flexDirection={'column'}>
      <OverviewDetailRow
        field={<Text tId={'REFERENCE_1'} />}
        value={orderDetails.order.merchantOrderReference1}
        copyButton
      />
      <OverviewDetailRow field={<Text tId={'LOAN_ID'} />} value={orderDetails.id} copyButton />
      <OverviewDetailRow field={<Text tId={'CREATED_AT'} />} value={formatDateTimeReadable(orderDetails.createdAt)} />
      {showClientData && (
        <OverviewDetailRow
          field={<Text tId={'CLIENT_CONTACT_EMAIL'} />}
          value={loan.onboardingDetails[0].invitation.email}
        />
      )}
      <OverviewDetailRow
        field={<Text tId={'PURCHASE_COUNTRY_TITLE'} />}
        value={<PurchaseCountryWithFlag purchaseCountry={loan.purchaseCountry} />}
      />
    </Box>
  ) : (
    <></>
  );
};

export { OrderHeaderDetails };
